import { EventObject } from '@xstate/store-react';
import { AppRoute } from '../../../enums/appRoutes';
import { StoreContext } from '../../../models/store/context';
import { QuoteStatus } from '../../../models/store/quoteStatus';
import { log } from '@domgen/shared/utils/log';
import { StoreEvent } from '../../../enums/storeEvent';

/**
 * Handles quote error, this is different to a failure in the fact that a quote was returned but it didn't have the expected properties to be rendered. In this scenario we still want to route to the error page and set the quote status to error so that we can display the appropriate message to the user.
 *
 * TODO: Discuss whether we want to differentiate between a quote error and a quote failure in the UI, as currently both scenarios will route to the same error page but with different messaging. We could potentially route to a different page for quote errors if we wanted to provide more specific guidance to the user on how to resolve the issue. This may be where we have a different page for quote errors that provides more specific guidance to the user on how to resolve the issue, while quote failures could route to a more generic error page that simply informs the user that something went wrong and to try again later.
 * @param context Current store context.
 * @param _event Unused event payload.
 * @param enqueue Store enqueue helpers used for navigation emission.
 * @returns Updated context with error quote status.
 */
export const quoteError = <T extends EventObject = EventObject>(
  context: StoreContext,
  _event: T,
  enqueue: {
    effect: (effect: () => Promise<void>) => void;
    emit: { navigate: (payload: { path: AppRoute; replace?: boolean }) => void };
  },
): StoreContext => {
  /** Specific behaviour to log the quote */
  log.debug({ message: StoreEvent.QUOTE_ERROR, data: { quote: context.quote } });
  enqueue.emit.navigate({ path: AppRoute.ERROR });
  return { ...context, quote: { status: QuoteStatus.ERROR } };
};
